export const MINIMAL_PRICE_PLN_GROSZ = 100;
